<template>
  <div
    id="selected-vessel-container-picture"
    ref="selectedVesselContainerPicture"
    v-show="shoulBeDisplay"
  >
    <template v-if="!isMobileView">
      <div
        class="
          selected-container-picture-header
          flex
          items-center
          px-5
          py-4
          gap-10
        "
      >
        <div class="flex gap-3 items-center">
          <span class="calendar-icon material-icons-outlined flex-shrink-0">
            calendar_month
          </span>
          <span class="aisea-text-14-300-black flex-shrink-0">{{
            timestampDisp
          }}</span>
        </div>
        <div class="flex gap-3 truncate w-1/2 items-center">
          <span class="person-icon material-icons-outlined flex-shrink-0">
            person_outline
          </span>
          <span class="truncate aisea-text-14-300-black">{{ enterpriseUserNameDisp }}</span>
        </div>
      </div>
    </template>
    <vx-card-with-slot-header
      class="
        selected-vessel-container-picture-card
        fixed
        top-0
        left-0
        right-0
        bottom-0
        w-full
        h-full
      "
    >
      <template v-slot:header>
        <div
          class="
            selected-container-picture-header
            flex
            items-center
            px-5
            py-4
            gap-10
          "
        >
          <div class="flex gap-3 items-center">
            <span class="calendar-icon material-icons-outlined flex-shrink-0">
              calendar_month
            </span>
            <span class="aisea-text-14-300-black flex-shrink-0">{{
              timestampDisp
            }}</span>
          </div>
          <div class="flex gap-3 truncate w-1/2 items-center">
            <span class="person-icon material-icons-outlined flex-shrink-0">
              person_outline
            </span>
            <span class="truncate aisea-text-14-300-black">{{ enterpriseUserNameDisp }}</span>
          </div>
        </div>
      </template>
      <div
        class="
          image-area-wrapper
          vs-con-loading__container
          relative
          flex
          justify-center
          items-baseline
          h-full
        "
      >
        <div
          class="image-wrapper image-area flex justify-center items-center"
          :style="imgWrapperStyle"
          ref="imageWrapper"
          :class="{ 'no-img': isNoImg }"
        >
          <img
            id="selected-container-img"
            ref="selectedContainerImg"
            :src="imgSrc"
            class="image-area cursor-move"
            :class="{ 'no-img': isNoImg }"
            draggable="false"
            @dragstart.stop.prevent=""
            @click.stop.prevent=""
            @mousedown.stop.prevent="handleMouseDown($event)"
            @mousemove.stop.prevent="handleMouseMove($event)"
            @mouseup.stop.prevent="handleMouseUp($event)"
            @touchstart.stop.prevent="handleTouchStart($event)"
            @touchmove.stop.prevent="handleTouchMove($event)"
            @touchend.stop.prevent="handleTouchEnd($event)"
          />
        </div>
        <div class="btn-container absolute flex flex-col gap-6">
          <vs-button
            class="btn-close btn-zoom-control"
            size="small"
            :color="'#333333'"
            style="font-size: 1.25rem"
            type="filled"
            icon="clear"
            @click="handleClickClose"
          ></vs-button>
          <div class="flex flex-col gap-3">
            <vs-button
              class="btn-zoom-control"
              size="small"
              :color="'#4A90E2'"
              style="font-size: 1.25rem"
              type="filled"
              icon="add"
              @click="handleClickZoomControlBtn(0.15)"
            ></vs-button>
            <vs-button
              class="btn-zoom-control"
              size="small"
              :color="'#4A90E2'"
              style="font-size: 1.25rem"
              type="filled"
              icon="remove"
              @click="handleClickZoomControlBtn(-0.15)"
              :disabled="!isZoomOutClickable"
            ></vs-button>
          </div>
        </div>
      </div>
    </vx-card-with-slot-header>
  </div>
</template>

<script>
import moment from "moment-timezone";
const NO_IMG = require("@/assets/images/no_image.png");
import { DeviceInfoMixin } from "@/mixins";
import VxCardWithSlotHeader from "@/components/vx-card/VxCardWithSlotHeader";

export default {
  name: "SelectedVesselContainerPicture",
  components: { VxCardWithSlotHeader },
  mixins: [DeviceInfoMixin],
  props: {
    selectedPicture: {
      type: Object,
      default: null,
    },
    selectedImgSrc: {
      type: String,
    },
    resetSelectedPicture: {
      type: Function,
      default: () => {},
    },
    popupActive: { type: Boolean, default: false },
  },
  data() {
    return {
      scale: 1.0,
      top: 0,
      left: 0,
      lastX: 0,
      lastY: 0,
      isDraging: false,
      isTicking: false,
      requestId: 0,
    };
  },
  watch: {
    originalPath() {
      this.initComponentState();
    },
  },
  computed: {
    imgWrapperStyle() {
      const { scale, top, left, isDraging } = this;
      return {
        transform: `translate(${left}px, ${top}px) scale(${scale})`,
        top: `calc(50% + ${top}px)`,
        left: `calc(50% + ${left}px)`,
        transition: isDraging ? "none" : "transform 0.3s ease",
      };
    },
    enterpriseUser() {
      if (!this.selectedPicture) return null;
      if (!this.selectedPicture.enterprise_user) return null;
      return this.selectedPicture.enterprise_user;
    },
    enterpriseUserName() {
      if (!this.enterpriseUser) return "";
      return this.enterpriseUser.name || "";
    },
    enterpriseUserNameEn() {
      if (!this.enterpriseUser) return "";
      return this.enterpriseUser.name_en || "";
    },
    enterpriseUserNameDisp() {
      if (!this.enterpriseUser) return "";
      return this.enterpriseUserName || this.enterpriseUserNameEn;
    },
    originalPath() {
      if (!this.selectedPicture) return "";
      if (!this.selectedPicture.original_path) return "";
      return this.selectedPicture.original_path;
    },
    imgSrc() {
      if (!this.selectedImgSrc) return NO_IMG;
      return this.selectedImgSrc;
    },
    isNoImg() {
      return this.imgSrc === NO_IMG;
    },
    timestampDisp() {
      if (!this.selectedPicture) return "";
      if (!this.selectedPicture.timestamp) return "";
      return moment(this.selectedPicture.timestamp).format("YYYY/MM/DD HH:mm");
    },
    isZoomOutClickable() {
      return this.scale > 0.15;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    isMobileView() {
      const MAX_WIDTH_IPAD_PRO_12 = 1366;
      return this.windowWidth < MAX_WIDTH_IPAD_PRO_12;
    },
    shoulBeDisplay() {
      if (!this.isMobileView) return true;
      return this.popupActive && this.selectedPicture;
    },
  },
  methods: {
    handleMouseDown(e) {
      this.lastX = e.clientX;
      this.lastY = e.clientY;
      this.isDraging = true;
    },
    handleMouseMove(e) {
      if (!this.isDraging || this.isTicking) return;
      this.isTicking = true;
      this.requestId = requestAnimationFrame(() => {
        this.top = this.top - this.lastY + e.clientY;
        this.left = this.left - this.lastX + e.clientX;

        this.lastX = e.clientX;
        this.lastY = e.clientY;
        this.isTicking = false;
      });
    },
    handleMouseUp() {
      cancelAnimationFrame(this.requestId);
      this.isDraging = false;
      this.isTicking = false;
    },
    handleTouchStart(e) {
      const touch = e.changedTouches[0];
      this.lastX = touch.clientX;
      this.lastY = touch.clientY;
      this.isDraging = true;
    },
    handleTouchMove(e) {
      if (!this.isDraging || this.isTicking) return;
      this.isTicking = true;
      const touch = e.changedTouches[0];
      this.requestId = requestAnimationFrame(() => {
        this.top = this.top - this.lastY + touch.clientY;
        this.left = this.left - this.lastX + touch.clientX;

        this.lastX = touch.clientX;
        this.lastY = touch.clientY;
        this.isTicking = false;
      });
    },
    handleTouchEnd() {
      cancelAnimationFrame(this.requestId);
      this.isDraging = false;
      this.isTicking = false;
    },
    handleClickZoomControlBtn(val) {
      this.scale += val;
    },
    initComponentState() {
      // transformの動きをなくすため、画面再描画後に初期化する
      this.isDraging = true;
      cancelAnimationFrame(this.requestId);
      this.scale = 1.0;
      this.top = 0;
      this.left = 0;
      this.lastX = 0;
      this.lastY = 0;
      this.isTicking = false;
      this.requestId = 0;
      setTimeout(() => {
        this.isDraging = false;
      });
    },
    handleClickClose() {
      this.resetSelectedPicture();
      this.initComponentState();
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
#selected-vessel-container-picture {
  --image-wrapper-height: 100%;
  .selected-vessel-container-picture-card {
    z-index: 51000;
    @media screen and (min-width: $max-width-ipad-pro-12) {
      position: initial;
      overflow: hidden;
    }
  }
  .vx-card__header {
    padding: 0;
    .vx-card__title {
      width: 100%;
    }
    .selected-container-picture-header {
      background-color: $aisea-white;
      @media screen and (min-width: $max-width-ipad-pro-12) {
        display: none;
      }
    }
  }
  .selected-container-picture-header {
    .calendar-icon,
    .person-icon {
      font-size: 18px;
      color: $aisea-gray;
    }
  }
  .vx-card__collapsible-content {
    height: 100%;
    .vx-card__body {
      height: 100%;
      padding: 0;
      .image-area-wrapper {
        width: 100%;
        @media screen and (min-width: $max-width-ipad-pro-12) {
          aspect-ratio: 1.4 / 1;
          align-items: center;
        }
        #selected-container-img {
          max-width: 100%;
          width: 100%;
          object-fit: contain;
          aspect-ratio: 1.4/1;
          object-position: top;
          &.no-img {
            width: 100%;
            max-width: 100px;
            min-width: 100px;
            height: 100px;
          }
        }
        .btn-container {
          top: 1.25rem;
          right: 1.25rem;
          .btn-zoom-control.includeIconOnly.small .vs-icon {
            font-size: 1.25rem !important;
          }
        }
        .btn-close {
          @media screen and (min-width: $max-width-ipad-pro-12) {
            display: none;
          }
        }
      }
    }
  }
}
</style>